import { render, staticRenderFns } from "./MsButton.vue?vue&type=template&id=6a852c70&"
import script from "./MsButton.vue?vue&type=script&lang=js&"
export * from "./MsButton.vue?vue&type=script&lang=js&"
import style0 from "./MsButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports